"use client";

import React from "react";

interface BodyLineTextProps {
  children: React.ReactNode;
  wrapperClassName?: string;
  textClassName?: string;
}

export default function HeadlineText({
  children,
  wrapperClassName = "",
  textClassName = "",
}: BodyLineTextProps) {
  return (
    <div
      className={` ${wrapperClassName} flex justify-center items-center md:pt-17.5 pt-9`}
    >
      <h1
        className={`w-full ${textClassName} text-3xl text-center sm:text-3xl md:text-4xl lg:text-5xl xl:text-[55.13px] font-semibold text-custom-blue capitalize`}
      >
        {children}
      </h1>
    </div>
  );
}
